var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingAndReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.218,
    height: 18.202,
    viewBox: "0 0 18.218 18.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-1.956 -1.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "favorite",
    d: "M11.9,2.544l2.089,4.542a.96.96,0,0,0,.636.545l4.723.727A.822.822,0,0,1,19.89,9.81l-3.452,3.542a1.268,1.268,0,0,0-.272.817l.817,4.9a.912.912,0,0,1-1.272,1l-4.269-2.362a.681.681,0,0,0-.817,0L6.356,20.074a.877.877,0,0,1-1.272-1l.817-4.9a.916.916,0,0,0-.272-.817L2.178,9.81a.944.944,0,0,1,.545-1.544L7.446,7.54a.779.779,0,0,0,.636-.545l2.089-4.542A.985.985,0,0,1,11.9,2.544Z",
    fill: "#37bdb0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingAndReview);
export default __webpack_public_path__ + "static/media/Rating_and_Review.b6aff4f5866ba80aaa50712ba5e8480c.svg";
export { ForwardRef as ReactComponent };